import { ActionKeys } from '~/actions/constants';
import * as prodAnalyticsActions from '~/actions/prod-analytics.actions';
import { call, takeLatest } from 'redux-saga/effects';
import prodAnalyticsService from '~/services/prod-analytics.service';

function* sendTrackEvent(action: ReturnType<typeof prodAnalyticsActions.sendTrackEvent>) {
  try {
    yield call(prodAnalyticsService['heap'].sendTrackEvent, action.name, action.properties);
  } catch (e) {
    //
  }
}

function* addEventProperties(action: ReturnType<typeof prodAnalyticsActions.addEventProperties>) {
  try {
    yield call(prodAnalyticsService['heap'].addEventProperties, action.properties);
  } catch (e) {
    //
  }
}

export default [
  takeLatest(ActionKeys.PROD_ANALYTICS_TRACK, sendTrackEvent),
  takeLatest(ActionKeys.PROD_ANALYTICS_ADD_EVENT_PROPERTIES, addEventProperties),
];
